import { FeatureFlag, get as getFeatureFlag } from '../FeatureFlagService';
import { FeatureFlagValue } from '../FeatureFlagService/FeatureFlagService';

import FreshdeskHelpWidgetService from './FreshdeskHelpWidgetService';
import ZendeskHelpWidgetService from './ZendeskHelpWidgetService';
import type { HelpWidgetService } from './types';

function resolveBasedOnFeatureFlag(hasFresdeshToZendeskMigrationEnabled?: FeatureFlagValue): HelpWidgetService {
  return hasFresdeshToZendeskMigrationEnabled ? ZendeskHelpWidgetService : FreshdeskHelpWidgetService;
}

function getFeatureFlagValue() {
  return getFeatureFlag(FeatureFlag.EnableFreshdeskToZendeskMigration);
}

const FlagBasedHelpWidgetService: HelpWidgetService & {
  initialize: (hasFresdeshToZendeskMigrationEnabled: FeatureFlagValue) => void;
} = {
  initialize: function (hasFresdeshToZendeskMigrationEnabled?: FeatureFlagValue) {
    resolveBasedOnFeatureFlag(hasFresdeshToZendeskMigrationEnabled).initialize();
  },
  show: function () {
    resolveBasedOnFeatureFlag(getFeatureFlagValue()).show();
  },
  showContactUs: function (subject: string, description: string) {
    resolveBasedOnFeatureFlag(getFeatureFlagValue()).showContactUs(subject, description);
  },
};

export default FlagBasedHelpWidgetService;
